import React from 'react';
import { Box, Typography, Alert, AlertTitle } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

interface MaintenanceBannerProps {
  message: string;
}

const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({ message }) => {
  return (
    <Alert 
      severity="warning" 
      icon={<ConstructionIcon />}
      sx={{
        borderRadius: 0,
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 1100,
      }}
    >
      <AlertTitle>Режим обслуживания</AlertTitle>
      <Typography variant="body2">
        {message || 'Бот отключен для обычных пользователей'}
      </Typography>
    </Alert>
  );
};

export default MaintenanceBanner;
